import { FC } from 'react';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import Container from 'src/common/components/business/ExpandStore/ChanceDetailDrawer/Container';

/**
 * 机会点详情信息抽屉
 * @Description 机会点详情页面
 * 1109 标准版数据迁移引用该组件，添加参数 hideOperate 隐藏顶部导入编辑等相关按钮
 */
const ChanceDetailDrawer: FC<{
  id,
  open,
  setOpen,
  /** 编辑 */
  setFormDrawerData?,
  /** 刷新机会点详情 */
  refreshDetail?,
  /** 表单支持直接编辑的时候时候返回刷新列表, 用于刷新数据，如提交审批，保存等 */
  onSearch?,
  /** 刷新列表当前页 */
  onSearchCurrentPage?,
  /** 上传文件更新 */
  updateHandle?,
  /** 隐藏操作按钮 */
  hideOperate?,
  /** 禁用匹配商圈点击详情 */
  disabledArea?,
  /** 是否废弃机会点 */
  isRecycle?,
}> = ({
  id,
  open,
  setOpen,
  setFormDrawerData, // 编辑
  refreshDetail, // 刷新机会点详情
  onSearch, // 表单支持直接编辑的时候时候返回刷新列表, 用于刷新数据，如提交审批，保存等
  onSearchCurrentPage, // 刷新列表当前页
  updateHandle, // 上传文件更新
  hideOperate = false, // 隐藏操作按钮
  disabledArea = false, // 禁用匹配商圈点击详情
  isRecycle = false, // 是否废弃机会点
}) => {

  const bigdataFn = useBigdataFn(); // 使用埋点 Hook

  const methods = useMethods({

    onClose() {
      setOpen(false);
      bigdataFn('e0a85e42-43a1-4d77-90ef-9ce740f8b553', '机会点详情-关闭', '', { op_block: '机会点管理', op_event: ``, });
    },

  });

  return (
    <V2Drawer
      open={open}
      onClose={methods.onClose}
      destroyOnClose
      contentWrapperStyle={true ? {
        width: '76%',
        minWidth: '1100px',
        maxWidth: 'none',
      } : {}}
      className={styles.chancePointDrawer}
    >
      <Container
        id={id}
        onClose={methods.onClose}
        setFormDrawerData={setFormDrawerData}
        refreshDetail={refreshDetail}
        onSearch={onSearch}
        onSearchCurrentPage={onSearchCurrentPage}
        updateHandle={updateHandle}
        hideOperate={hideOperate}
        disabledArea={disabledArea}
        isRecycle={isRecycle}
      />
    </V2Drawer>
  );
};

export default ChanceDetailDrawer;
